import http from "../http-common";

class PrimaryMenuService {
  getAllprimaryMenu() {
    return http.get("/master-page/header-menu");
  }
}

export default new PrimaryMenuService();
